<template>
  <div v-loading="pageLoading" class="CreateOrder">
    <div v-if="showCreditTips" class="credit-content">
      <a-alert
          class="credit-tips"
          closable
          show-icon
          :type="creditType"
      >
        <a-icon slot="icon" theme="filled" type="info-circle"/>
        <marquee slot="message" style="width: 230px">
          {{ creditMessage }}
        </marquee>
      </a-alert>
    </div>
    <div v-if="standardList.length">
      <div class="order-tab">
        <a-tabs v-model="productType" class="cartype-tabs" @change="tabsChange">
          <a-tab-pane v-for="tab in standardList" :key="tab.value" :disabled="disable_tab||isEditPage || tab.disabled">
            <div slot="tab" v-track-click='{trackName:`在线下单${tab.label}`}'>
              <img :src="filterImage(tab.value)" class="tabImage" alt="">
              <span>{{ tab.label }}</span>
            </div>
          </a-tab-pane>
        </a-tabs>
        <a-button
            v-if="!isEditPage"
            v-track-click="{ trackName: '在线下单-批量下单' }"
            class="batch-create"
            @click="importOrder"
        >
          <img src="@/assets/img/icon/icon_piliang.png" alt="">
          批量下单
        </a-button>
      </div>
      <pureOrderManageCreate
          v-if="filterBody(tabListType.PURE_TRANSPORT) && emailRules.length"
          ref="pureTransportRef"
          :email-rules="emailRules"
          @showTips="showTips"
          @refreshRule="onRefreshRule"
          @changeTabStatus="changeTabStatus"
      ></pureOrderManageCreate>
      <warehouse-create
          v-else-if="filterBody(tabListType.WAREHOUSE)&&isLoad"
          :key="tabListType.WAREHOUSE"
          :product-list="productList"
          :is-discharge.sync="isDischarge"
          :standard-list="standardList"
          :show-car-type="standardList.length > 1"
          @showTips="showTips"
          @changeDischarge="changeDischarge"
      />
      <warehouse-create
          v-else-if="filterBody(tabListType.DELIVER_TRANSPORT)&&isLoad"
          :key="tabListType.DELIVER_TRANSPORT"
          :product-list="productList"
          :tab="tabListType.DELIVER_TRANSPORT"
          :is-discharge.sync="isDischarge"
          :standard-list="standardList"
          :show-car-type="standardList.length > 1"
          @showTips="showTips"
          @changeDischarge="changeDischarge"
      />
      <standard
          v-else-if="filterBody(tabListType.CP) && productType&&isLoad"
          ref="standardRef"
          :product-code="productType"
          :is-discharge.sync="isDischarge"
          :has-warehouse="hasWarehouse"
          @changeCityTab="changeCityTab"
          @changeTab="changeTab"
          @showTips="showTips"
          @changeTabStatus="changeTabStatus"
      />
      <transport
          v-else-if="filterBody(tabListType.TRANSPORT)&&isLoad"
          ref="transportRef"
          @showTips="showTips"
          @changeTabStatus="changeTabStatus">
      </transport>
      <auth v-if="authFlag" @success="authSuccess" @cancel="authFlag = false"></auth>
    </div>
    <div v-else class="no-contract">
      <img src="@/assets/img/pic_shujukq.png"/>
      <p>当前没有合同</p>
    </div>
    <a-modal v-model="tosign" title="" :closable="false" :footer="null" :mask-closable="false">
      <div class="okTips">
        <p class="titletext">
          <img src="@/assets/img/auth/icon_warning_circle_field.png" alt="">
          签约后才能下单
        </p>
        <p class="tips_text">请先前往签约</p>
        <div class="btn">
          <a-button type="primary" @click="handleSign">
            前往签约
          </a-button>
        </div>
      </div>
    </a-modal>
    <CarriersSelectDialog v-if="!oneMoreOrder && !isEditOrder" ref="CarriersSelect" @select="handleSelect"></CarriersSelectDialog>
  </div>
</template>

<script>
// 纯运输=运输 仓配一体=仓配
import {mapActions, mapMutations} from 'vuex'
import iconZhuanche from '@/assets/img/icon/icon_zhuanche.png'
import iconLingdan from '@/assets/img/icon/icon_lingdan.png'
import iconChengpei from '@/assets/img/icon/icon_chengpei.png'
import iconCang from '@/assets/img/icon/icon_cang.png'
import iconHuoyun from '@/assets/img/icon/icon_huoyun.png'
import Auth from '@/components/authentication/Auth.vue'
// import { getSignType } from '@/api/enterprise/authentication.js'
import {EventBus} from '@/utils/event-bus'
import {getSignType} from '@/api/enterprise/authentication'

import {getCredit} from '@/api/layout'
import {RULE_TYPE} from '@/constants/ruleConfig'
import pureOrderManageCreate from "@/pages/orderManage/pureOrderManageCreate/index.vue";
import { tabListType, TabTypeIndex } from "@/pages/orderManage/constant";
import {
  getInterface,
  getContract,
  getWareHouseContract,
  getConfig,
  getContractsetting,
  getLevelTree,
  getRatio,
  getLevelquery,
  getRules
} from './api'
import WarehouseCreate from '../warehouseOrder/warehouseCreate/WarehouseCreate.vue'
import standard from "./StandardOrderManageCreate/index.vue"
import transport from "./OrderManageCreate/index.vue"
import CarriersSelectDialog from './components/carriersSelectDialog.vue'
import {getGoodsVerifyConfig} from './StandardOrderManageCreate/goodsTable'

const standardType = {
  CP001: 'CP001',
  CP002: 'CP002',
  CP003: 'CP003',
  CP004: 'CP004',
}
export const goodsVerifyConfig = {}
export default {
  name: 'CreateOrder',
  components: {
    WarehouseCreate,
    standard,
    transport,
    Auth,
    CarriersSelectDialog,
    pureOrderManageCreate,
  },
  data() {
    return {
      pageLoading: false,
      productType: '',
      standardList: [], // tab数据
      isEditPage: true,
      imageList: {
        'CP001': iconZhuanche,
        'CP002': iconLingdan,
        'CP003': iconChengpei,
        'CP004': iconChengpei,
        'warehouse': iconCang,
        'transport': iconHuoyun,
        'PURE_TRANSPORT': iconZhuanche,
        'DELIVER_TRANSPORT': iconCang
      },
      tabListType,
      noAuthentication: false,
      authFlag: false,
      tosign: false,
      oneMoreOrder: false,
      isEditOrder: false,
      productList: [], // 标准产品列表
      ruyeWhite: false,
      ruyeWhiteList: [],
      isLoad: true,
      showCreditTips: false,
      creditPercentage: 0,
      switchRatio: 0,
      isDischarge: false, // 一装多卸
      levelOptions: [],
      levelParams: null,
      ratioList: [],
      goodLevelSku: {},
      isProjectControl: false,
      projectTanantList: [],
      disable_tab: false,
      dischargeList: [], // 一装多卸白名单
      emailRules: [],
      showPureOrder: false
    }
  },
  provide() {
    return {
      order: this
    }
  },
  computed: {
    creditMessage() {
      let message = ''
      if (this.creditPercentage >= 100) {
        message = '截至昨天您的回款已逾期，暂无法提交订单，请尽快处理!'
      } else {
        message = `截止昨天不包括在途的授信余额已占用${this.creditPercentage}%,请您及时进行回款操作，否则将有可能影响正常下单`
      }
      return message
    },
    creditType() {
      let type = ''
      if (this.creditPercentage >= 100) {
        type = 'error'
      } else {
        type = 'warning'
      }
      return type
    },
    hasWarehouse() {
      return this.standardList.filter(item => item.value === tabListType.WAREHOUSE).length > 0
    }
  },
  async created() {
    this.createdHandle()
  },
  async mounted() {
    this.getWarehouseMultiDischarge()
    const {creditCode, customers} = this.$store.state.user
    if ((customers && customers.length === 1) && !this.isEditOrder && !this.oneMoreOrder) {
      this.standardList = []
      this.init()
      this.getRuyeWhite()
    } else if (creditCode && !this.oneMoreOrder && !this.isEditOrder) {
      this.$refs.CarriersSelect.init()
    }
  },
  beforeDestroy() {
    EventBus.$off('handleSelect')
  },
  methods: {
    ...mapMutations('user', ['SET_USER_DATA']),
    ...mapActions('orderRules', ['getOrderRules']),
    async createdHandle() {
      const {path, query} = this.$route
      this.oneMoreOrder = !!query.oneMoreOrder  // 再来一单
      this.ratioList = await getRatio({})
      this.getConfig()
      this.getProjectControl()
      // 获取签约状态
      // const signData = await getSignType({
      //     ids: [this.$store.state.user.customerId]
      // })
      // this.tosign = !signData.contractStatus
      this.isEditOrder = path === '/order/editOrder'
      const {customerId, creditCode, customers} = this.$store.state.user
      this.noAuthentication = !customerId || !!creditCode
      if (creditCode && customers && customers.length !== 1) {
        this.isLoad = false
      }
      if (this.noAuthentication && !this.oneMoreOrder && !this.isEditOrder && !(customers.length === 1)) {
        this.standardList = [
          {
            value: standardType.CP001,
            label: '干线专车'
          },
          {
            value: standardType.CP002,
            label: '干线零担'
          },
          {
            value: standardType.CP003,
            label: '城配'
          },
          {
            value: tabListType.WAREHOUSE,
            label: '仓'
          }
        ]
        this.productType = standardType.CP001
        this.isEditPage = false
      }
      if (customerId && !creditCode) {
        this.init()
        this.getRuyeWhite()
        this.getWarehouseMultiDischarge()
      }
      if (creditCode && (this.isEditOrder || this.oneMoreOrder)) {
        this.isLoad = false
        this.selectCustomer(query.customerCode)
      }
      EventBus.$on('handleSelect', this.handleSelect)
    },
    onRefreshRule(carrierTenantId){
      // this.getEmialRules(carrierTenantId)
      this.init(carrierTenantId)
    },
    async getEmialRules(carrierTenantId) {
      // this.showPureOrder = false;
      const res = await getRules(
          {
            customerCode: this.selectCarrier?.customerCode || this.$store.state.user?.customerCode,
            carrierTenantId: carrierTenantId || this.selectCarrier?.ownerTenantId || this.$store.state.user?.tenantId,
            processModuleCode: 'EMAIL_CREATE_ORDER',
            configChannel:'PC_CREATE',
          }
      )
      const rules = res.currentRules;
      // if(carrierTenantId && rules.length === 0) {
      //   this.createdHandle();
      //   return
      // }
      if (rules.length) {
        this.$set(this,'emailRules', rules)
        // this.showPureOrder = true;
        // this.emailRules = rules;
      }else {
        this.$set(this,'emailRules', [])
        // this.showPureOrder = true;
      }
    },
    async getProjectControl() {
      const res = await getConfig({
        appId: "1004",
        keys: ['oms.project.control']
      })
      this.projectTanantList = res.configs[0]?.value?.split(',')
      const tenantId = this.$store.state.user?.tenantId
      this.isProjectControl = this.projectTanantList.includes(tenantId) || false
    },
    async getConfig() {
      this.goodLevelSku = await getLevelquery({
        convertMap: true
      })
    },
    changeDischarge(value) {
      this.$set(this, 'isDischarge', value)
    },
    async getWarehouseMultiDischarge() {
      const pageScene = this.$route.query.scene
      if(pageScene === tabListType.WAREHOUSE || pageScene === tabListType.DELIVER_TRANSPORT) {
        this.isDischarge = this.$route.query.scene === tabListType.DELIVER_TRANSPORT
        return
      }
      const res = await getConfig({
        appId: "1004",
        keys: ['oms.warehouse.multi.discharge']
      })
      this.dischargeList = res.configs[0]?.value?.split(',')
      const customerCode = this.$store.state.user?.customerCode
      this.isDischarge = !this.dischargeList.includes(customerCode)

    },
    async getRuyeWhite() {
      const res = await getConfig({
        appId: "1002",
        keys: ['oms.order.ry.filter']
      })
      this.ruyeWhiteList = res.configs[0]?.value?.split(',')
      const customerCode = this.$store.state.user?.customerCode
      this.ruyeWhite = this.ruyeWhiteList.includes(customerCode)
    },
    async selectCustomer(code) {
      const {customers} = this.$store.state.user
      const data = customers.filter(item => item.customerCode === code)[0]
      const [select] = await getSignType({ids: [data.customerId]})
      const {carrierTenantId, carrierTenantName, id, customerCode, customerName} = select
      const accountData = {
        id: customers.filter(item => item.customerId === id)[0].orgId,
        identityId: id
      }
      localStorage.setItem('accountData', JSON.stringify(accountData))
      const selectCarriering = {
        tenantId: carrierTenantId,
        tenantName: carrierTenantName,
        customerId: id,
        customerCode,
        customerName,
      }
      Object.keys(selectCarriering).forEach(item => {
        this.SET_USER_DATA([item, selectCarriering[item]])
      })
      this.isLoad = true
      this.standardList = []
      this.init()
      this.getRuyeWhite()
      this.getWarehouseMultiDischarge()
    },
    async handleSelect(select) {
      this.isLoad = true
      this.selectCarrier = select
      const {customerCode, ownerTenantId} = select
      // this.isDischarge = !this.dischargeList.includes(customerCode)
      this.isProjectControl = this.projectTanantList.includes(ownerTenantId)
      this.ruyeWhite = this.ruyeWhiteList.includes(customerCode)
      this.productType = ''
      this.standardList = []
      this.init()
      const res = await getCredit({
        tenantId: select.ownerTenantId,
        customerCode: select.customerCode
      })
      this.showCreditTips = res.warning
      this.creditPercentage = ((res.proportion || 0) * 100).toFixed()
      this.switchRatio = ((res.switchRatio || 0) * 100).toFixed()
    },
    async showTips() {
      const {tenantId, customerCode} = this.$store.state.user
      const res = await getCredit({
        customerCode,
        tenantId
      })
      this.showCreditTips = res.warning
      this.creditPercentage = ((res.proportion || 0) * 100).toFixed()
      this.switchRatio = ((res.switchRatio || 0) * 100).toFixed()
    },
    handleSign() {
      this.$router.push('/profile')
    },
    authSuccess() {
      this.$router.push('/authentication')
    },
    changeCityTab() {
      this.productType = this.standardList[2].value
    },
    changeTab(val) {
      if (val) {
        this.productType = standardType.CP001
      } else {
        this.productType = standardType.CP002
      }
    },
    async init(carrierTenantId=null) {
      this.pageLoading = true;
      // if(carrierTenantId && this.emailRules.length>0 && this.standardList.find(item=>item.label==='纯运输')){
      //   this.standardList = []
      // }
      await this.getEmialRules(carrierTenantId);
      await this.getOrderRules(RULE_TYPE.orderRules)
      this.getContractsetting()
      // 获取货品验证配置
      goodsVerifyConfig.value = await getGoodsVerifyConfig()
      if(this.emailRules.length) { // 命中邮件下单规则
        this.$set(this,'standardList',[{
          value: tabListType.PURE_TRANSPORT,
          // value: tabListType.TRANSPORT,
          label: '运输'
        }])
      }else { // 非规邮件下单规则走老逻辑
        if(carrierTenantId){
          this.standardList = []
        }
        // 获取标准产品
        const res = await getInterface({})
        const newArr = res.sort((a, b) => {
          return a.productCode.localeCompare(b.productCode)
        })
        this.productList = newArr || []
        if (newArr && newArr.length > 0) {
          this.standardList = []
          newArr.forEach((e) => {
            if (standardType.CP003 === e.productCode || standardType.CP004 === e.productCode) {
              if (this.standardList.filter(n => n.label === '城配').length <= 0) {
                this.standardList.push({
                  value: e.productCode,
                  label: '城配'
                })
              }
            } else {
              this.standardList.push({
                value: e.productCode,
                label: e.productName
              })
            }

          })
        } else {
          // 没有标准产品
          const contract = await getContract({
            cargoOwnerCode: this.$store.state.user.customerCode,
            status: 'ENABLED',
            needAllContracts: true,
          })
          if (contract.length > 0) {
            this.standardList.push({
              value: 'transport',
              label: '货运'
            })
          }
        }
      }


      // 获取仓合同
      const warehouseContract = await getWareHouseContract({
        cargoOwnerCode: this.$store.state.user.customerCode
      })
      if (warehouseContract.STORAGE.length > 0) {
        this.standardList = this.standardList.concat([
          {
            value: tabListType.WAREHOUSE,
            label: '仓'
          },
          {
            value: tabListType.DELIVER_TRANSPORT,
            label: '仓配'
          }
        ])
      }
      if (this.standardList.length <= 0) {
        this.pageLoading = false;
        return
      }
      this.oneMoreOrder = !!this.$route.query.oneMoreOrder
      if (!this.oneMoreOrder) {
        this.isEditPage = !!this.$route.query.odrNo
      } else {
        this.isEditPage = false
      }
      if (this.$route.query.type && this.$route.query.scene === tabListType.DELIVER_TRANSPORT) { // 仓配一体
        this.productType = tabListType.DELIVER_TRANSPORT
      } else if(this.$route.query.type){
        this.productType = tabListType.WAREHOUSE
      }else if (!this.isEditPage && !this.oneMoreOrder) {
        this.productType = this.standardList[0].value
      } else if(this.emailRules.length>0) {
          this.productType = tabListType.PURE_TRANSPORT
        }else {
          this.productType = this.filterCode(this.$route.query.productCode) ? this.$route.query.productCode : this.setCode(this.$route.query.productCode)
        }
      if (this.oneMoreOrder) {
        if (this.productType === tabListType.WAREHOUSE) {
          this.standardList.forEach((e) => {
            if (e.value !== tabListType.WAREHOUSE) {
              e.disabled = true
            }
          })
        } else {
          this.standardList.forEach((e) => {
            if (e.value === tabListType.WAREHOUSE) {
              e.disabled = true
            }
          })
        }
      }
      const {creditCode, customers} = this.$store.state.user
      const oneMoreOrder = !!this.$route.query.oneMoreOrde
      const isEditPage = !!this.$route.query.odrNo
      // 下单时企业视角且只有一个用户时需要请求授信
      if (!!creditCode && !oneMoreOrder && !isEditPage && customers.length === 1) {
        this.showTips()
      }
      this.pageLoading = false;
    },
    async getContractsetting() {
      const {customerCode, tenantId} = this.$store.state.user
      const res = await getContractsetting({
        partATenantId: customerCode,
        partBTenantId: tenantId,
        status: 'ENABLED'
      })
      if (res.length) {
        const tree = [];
        const levelParams = {}
        res.forEach(level => {
          level.goodSetting.forEach(item => {
            item.goodsLevels.forEach(good => {
              const [goodsLevel1, goodsLevel2, goodsLevel3] = good
              if (levelParams[goodsLevel1]) {
                if (levelParams[goodsLevel1][goodsLevel2]) {
                  if (!levelParams[goodsLevel1][goodsLevel2][goodsLevel3]) {
                    levelParams[goodsLevel1][goodsLevel2][goodsLevel3] = item.warmLayerList
                  }
                } else {
                  levelParams[goodsLevel1][goodsLevel2] = {
                    [goodsLevel3]: item.warmLayerList
                  }
                }
              } else {
                levelParams[goodsLevel1] = {
                  [goodsLevel2]: {
                    [goodsLevel3]: item.warmLayerList
                  }
                }
              }
            })
          })
        })
        Object.keys(levelParams).forEach(first => {
          tree.push({
            name: first,
            children: Object.keys(levelParams[first]).map(second => {
              return {
                name: second,
                children: Object.keys(levelParams[first][second]).map(third => {
                  return {
                    name: third,
                  }
                })
              }
            })
          })
        })
        this.levelOptions = tree
        this.levelParams = levelParams
      } else {
        this.levelOptions = await getLevelTree();
      }
    },
    filterCode(code) {
      let flag = false
      this.standardList.forEach((e) => {
        if (e.value === code) {
          flag = true
        }
      })
      return flag
    },
    setCode(code) {
      let returnCode = ''
      if (code === standardType.CP004) {
        this.standardList.forEach((e) => {
          if (e.label === '城配') {
            returnCode = e.value
          }
        })
      } else {
        returnCode = this.standardList[0].value
      }
      return returnCode
    },
    tabsChange() {
      // if (Object.keys(standardType).includes(this.productType)) {
      //     this.$nextTick(() => {
      //         this.$refs.standardRef.changeTab()
      //     })
      // }
    },
    async importOrder() {
      const {customerId, creditCode} = this.$store.state.user
      if (!customerId && !creditCode) {
        this.authFlag = true
        return
      }

      // 标准导入
      if (tabListType.WAREHOUSE === this.productType || tabListType.DELIVER_TRANSPORT===this.productType) {
        this.$router.push({
          path: '/order/create-multiple',
          query: {
            type: TabTypeIndex[this.productType],
            menuName: '在线下单'
          }
        })
      } else if (this.filterBody(tabListType.CP) && this.productType) {
        this.$router.push({
          path: '/order/create-multiple',
          query: {
            menuName: '在线下单',
            productType: this.productType
          }
        })
      } else {
        // 非标准批量导入
        const resList = await getContract({
          cargoOwnerCode: this.$store.state.user.customerCode,
          status: 'ENABLED',
          needAllContracts: true,
        })
        if (resList.length <= 0) {
          this.$message.warning('未创建合同，无法下单')
          return
        }
        // 一单一议不允许下单
        const negotiationType = resList.map(data => data.negotiationType)
        if (negotiationType.includes('NEGOTIABLE')) {
          this.$message.warning('一单一议合同暂仅支持APP下单')
          return
        }
        this.$router.push({
          path: '/order/create-multiple',
          query: {
            menuName: '在线下单'
          }
        })
      }
    },
    filterImage(code) {
      return this.imageList[code]
    },
    filterBody(type) {
      return this.productType.includes(type)
    },
    changeTabStatus(value) {
      this.disable_tab = value;
    },
  }
}
</script>

<style lang="less" scoped>
.CreateOrder {
  min-height: 400px;
  padding-bottom: 50px;

  .credit-content {
    position: fixed;
    z-index: 200;
    width: 100%;
    left: 0;
    top: 8px;
  }

  .credit-tips {
    height: 48px;
    line-height: 48px;
    padding: 0 16px;
    background: #fff;
    border: none;
    box-shadow: 0px 7px 12px 1px rgb(126 126 126 / 15%);
    border-radius: 4px;
    margin: auto;
    margin-bottom: 16px;

    /deep/ .ant-alert-icon {
      top: 0;
    }

    /deep/ .ant-alert-message {
      margin-left: 24px;
      font-size: 14px;
    }

    /deep/ .ant-alert-close-icon {
      top: 13px;
    }
  }

  /deep/ .ant-alert-warning {
    width: 300px;

    .ant-alert-message {
      color: #FE5E08;
    }

    .ant-alert-icon {
      color: #FF9200;
    }
  }

  /deep/ .ant-alert-error {
    width: 40%;

    .ant-alert-message {
      color: #ED4934;
    }

    .ant-alert-icon {
      color: #ED4934;
    }
  }

  .no-contract {
    text-align: center;
    color: #969799;
    margin-top: 60px;

    img {
      width: 200px;
      height: 200px;
      margin-bottom: 20px;
    }
  }

  .order-tab {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .batch-create {
      background: linear-gradient(244deg, #06B889 0%, #24D69E 100%);
      border-radius: 4px;
      font-weight: 500;
      color: #FFFFFF;
      height: 48px;
      padding: 0 24px;
      line-height: 48px;
      border: none;

      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }

  .cartype-tabs {
    height: 112px;

    img {
      width: 96px;
      height: 96px;
    }

    /deep/ .ant-tabs-bar {
      height: 100%;

      .ant-tabs-nav {
        border-radius: 6px;
        background: #F2FBF8;
        border: 1px solid #E7E9EC;
        height: 112px;
        display: flex;
        align-items: center;
      }

      .ant-tabs-nav-container {
        height: 100%;
      }

      .ant-tabs-tab {
        height: 100%;
        padding: 0;
        margin: 0;
        font-size: 22px;
        font-weight: 500;
        color: #06B880;
        margin: 0 8px;
        transition: none;

        > div {
          padding: 0px 51px 0px 24px;
        }

        &:hover {
          color: #FFFFFF;
          background: linear-gradient(239deg, #06B889 0%, #24D69E 100%);
          box-shadow: 0px 10px 12px 0px rgba(7, 208, 145, 0.5);
          border-radius: 6px;
          // transition: all 1s;
        }
      }

      .ant-tabs-tab-active {
        background: linear-gradient(239deg, #06B889 0%, #24D69E 100%);
        box-shadow: 0px 10px 12px 0px rgba(7, 208, 145, 0.5);
        border-radius: 6px;
        color: #FFFFFF;
      }

      .ant-tabs-ink-bar {
        display: none !important;
      }
    }
  }

  .margin-left {
    margin-left: 10px;
  }
}

// ::v-deep .ant-tabs-bar{
//     margin: 0;
//     border-bottom: none;
// }
</style>
<style lang="less">
.create-btns {
  .align-right {
    .ant-btn {
      height: 48px;
      width: 120px;

      &.ant-btn-primary {
        width: 280px;
      }
    }
  }
}

.titletext {
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);

  img {
    width: 24px;
    height: 24px;
    vertical-align: top;
  }
}

.tips_text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 30px;
}

.btn {
  text-align: right;
  margin-top: 16px;

  button {
    margin-left: 8px;
  }
}
</style>
